import { findAppInfoByPathname } from '@wellesley/router/platformRoutes'
import { wlsly } from 'helpers/wlsly'
import dayjs from 'dayjs'

function localTime(date?: number | null) {
  return typeof date === 'number' && date > 0
    ? dayjs(date).format('M/D/YYYY, hh:mm:ss A')
    : 'n/a'
}

function buildNum(build?: number | string | null) {
  return typeof build === 'number' && build > 0
    ? `#${build}`
    : typeof build === 'string'
      ? build
      : 'local'
}

export const getBuildInfo = (pathname = window.location.pathname) => {
  const wlslyData = wlsly()?.platformData
  if (!wlslyData) return null

  const {
    appBuild,
    appBuildDate,
    appName,
    platformBuild,
    platformBuildDate,
    toolbarBuild,
    toolbarBuildDate,
  } = wlslyData

  return {
    appName: findAppInfoByPathname(pathname)?.name || appName,
    appBuild: buildNum(appBuild),
    appBuildDate: localTime(appBuildDate),
    platformBuild: buildNum(platformBuild),
    platformBuildDate: localTime(platformBuildDate),
    toolbarBuild: buildNum(toolbarBuild),
    toolbarBuildDate: localTime(toolbarBuildDate),
  }
}
